export const bottomNavigationLang = {
    home: 'خانه',
    categories: 'دسته‌بندی',
    search: 'جستجو',
    user: 'پروفایل',
};
